<p-dialog
  [(visible)]="visible"
  [header]="'page.declarations.synthese.modal.saisir-revendication.title' | translate"
  [modal]="true"
  [closable]="true"
  [dismissableMask]="false"
  appendTo="body"
  [style]="{ width: '50rem', height: 'auto' }"
  [contentStyle]="{ overflow: 'auto' }">

  <!-- Formulaire de saisie d'une revendication -->
  <form [formGroup]="formGroup" #form="ngForm" (ngSubmit)="onAjouterLot()" novalidate>
    <div class="row g-4 pt-4">

      <!-- Partie 1 : La déclaration -->
      <div class="col-12">
        <h6 class="fw-semibold mb-0">La déclaration</h6>
        <hr class="mt-1">
      </div>

      <!-- Type de revendication -->
      <div class="col-6">
        <p-floatlabel [variant]="form_entreposage?.disabled ? null : 'on'">
          <p-select
            inputId="type"
            formControlName="type"
            [options]="revendicationTypeOptions"
            optionLabel="label"
            optionValue="value">
          </p-select>
          <label for="type">{{ 'page.declarations.synthese.modal.saisir-revendication.type' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Cahier des charges -->
      <div class="col-6">
        <p-floatlabel [variant]="form_cahier?.disabled ? null : 'on'">
          <p-select
            inputId="cahier"
            formControlName="cahier"
            [options]="cahiers"
            optionLabel="libelle"
            [ngClass]="{'is-invalid': form.submitted && form_cahier.invalid}"
            (onChange)="loadProducts()">
          </p-select>
          <label for="cahier">{{ 'page.declarations.synthese.modal.saisir-revendication.cahier' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Date -->
      <div class="col-6" [ngClass]="{'pt-3': form_date?.disabled}">
        <p-floatlabel [variant]="form_date?.disabled ? null : 'on'">
          <p-datePicker
            inputId="date"
            formControlName="date"
            dateFormat="dd/mm/yy"
            [showIcon]="true"
            [iconDisplay]="'input'"
            [ngClass]="{'is-invalid': form.submitted && form_date.invalid}">
          </p-datePicker>
          <label for="date">{{ 'page.declarations.synthese.modal.saisir-revendication.date' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Entreposage -->
      <div class="col-6" [ngClass]="{'pt-3': form_entreposage?.disabled}">
        <p-floatlabel [variant]="form_entreposage?.disabled ? null : 'on'">
          <p-select
            inputId="entreposage"
            formControlName="entreposage"
            [options]="sites"
            optionLabel="adresse"
            appendTo="body"
            [ngClass]="{'is-invalid': form.submitted && form_entreposage.invalid}">
          </p-select>
          <label for="entreposage">{{ 'page.declarations.synthese.modal.saisir-revendication.entreposage' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Partie 2 : Le lot -->
      <div class="col-12">
        <h6 class="fw-semibold mb-0">Le lot</h6>
        <hr class="mt-1">
      </div>

      <!-- Produit + Cépages -->
      <div class="col-6">
        <p-floatlabel variant="on">
          <p-select
            inputId="produits"
            formControlName="produits"
            [options]="produits"
            optionLabel="libelle"
            appendTo="body"
            [ngClass]="{'is-invalid': form.submitted && form_produits.invalid}">
          </p-select>
          <label for="produits">{{ 'page.declarations.synthese.modal.saisir-revendication.produit' | translate }}</label>
        </p-floatlabel>
      </div>
      <div class="col-6">
        <p-floatlabel variant="on">
          <p-multiSelect
            inputId="cepages"
            formControlName="cepages"
            [options]="cepages"
            optionLabel="libelle"
            display="chip"
            [maxSelectedLabels]="10"
            [ngClass]="{'is-invalid': form.submitted && form_cepages.invalid}">
          </p-multiSelect>
          <label for="cepages">{{ 'page.declarations.synthese.modal.saisir-revendication.cepages' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Destinations -->
      <div class="col-12">
        <p-floatlabel variant="on">
          <p-multiSelect
            inputId="destinations"
            formControlName="destinations"
            [options]="destinations"
            optionLabel="libelle"
            display="chip"
            [ngClass]="{'is-invalid': form.submitted && form_destinations.invalid}">
          </p-multiSelect>
          <label for="destinations">{{ 'page.declarations.synthese.modal.saisir-revendication.destinations' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Numéro de lot + Logement -->
      <div class="col-6">
        <p-floatlabel variant="on">
          <input
            pInputText
            class="w-100"
            id="lot"
            formControlName="lot"
            [ngClass]="{'is-invalid': form.submitted && form_lot.invalid}" />
          <label for="lot">{{ 'page.declarations.synthese.modal.saisir-revendication.numeroLot' | translate }}</label>
        </p-floatlabel>
      </div>
      <div class="col-6">
        <p-floatlabel variant="on">
          <input
            pInputText
            class="w-100"
            id="logement"
            formControlName="logement"
            [ngClass]="{'is-invalid': form.submitted && form_logement.invalid}" />
          <label for="logement">{{ 'page.declarations.synthese.modal.saisir-revendication.logement' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- TAV / degré + Volume -->
      <div class="col-6">
        <p-floatlabel variant="on">
          <p-inputNumber
            inputId="degre"
            formControlName="degre"
            class="w-100"
            [useGrouping]="false"
            [minFractionDigits]="0"
            [maxFractionDigits]="2"
            [ngClass]="{'is-invalid': form.submitted && form_degre.invalid}">
          </p-inputNumber>
          <label for="degre">{{ 'page.declarations.synthese.modal.saisir-revendication.degre' | translate }}</label>
        </p-floatlabel>
      </div>
      <div class="col-6">
        <p-floatlabel variant="on">
          <p-inputNumber
            inputId="volume"
            formControlName="volume"
            styleClass="w-100"
            [useGrouping]="false"
            [minFractionDigits]="0"
            [maxFractionDigits]="2"
            [ngClass]="{'is-invalid': form.submitted && form_volume.invalid}">
          </p-inputNumber>
          <label for="volume">{{ 'page.declarations.synthese.modal.saisir-revendication.volume' | translate }}</label>
        </p-floatlabel>
      </div>

      <!-- Labels environnementaux + Autres labels -->
      <div class="col-6">
        <p-floatlabel variant="on">
          <p-multiSelect
            inputId="environnementLabels"
            formControlName="environnementLabels"
            [options]="environnementLabels"
            optionLabel="libelle"
            display="chip"
            [ngClass]="{'is-invalid': form.submitted && form_labelsEnv.invalid}">
          </p-multiSelect>
          <label for="environnementLabels">{{ 'page.declarations.synthese.modal.saisir-revendication.labels' | translate }}</label>
        </p-floatlabel>
      </div>
      <div class="col-6">
        <p-floatlabel variant="on">
          <input
            pInputText
            class="w-100"
            id="autres-labels-environnement"
            formControlName="autresEnvironnementLabels"
            [ngClass]="{'is-invalid': (form.submitted && form_autresLabelsEnv.invalid) || (form_labelsEnv.value === 'aucun' && form_autresLabelsEnv.value === '')}"
            [attr.tabindex]="isAucunEnvLabelSelected ? '-1' : '0'" />
          @if (isAutreEnvLabelSelected) {
            <label for="autres-labels-environnement">{{ 'page.declarations.synthese.modal.saisir-revendication.autres-labels-obligatoire' | translate }}</label>
          } @else {
            <label for="autres-labels-environnement">{{ 'page.declarations.synthese.modal.saisir-revendication.autres-labels' | translate }}</label>
          }
        </p-floatlabel>
      </div>

      <!-- Observation -->
      <div class="col-12">
        <p-floatlabel variant="on">
          <textarea
            pTextarea
            class="w-100"
            id="observation"
            formControlName="observation"
            rows="3"
            [ngClass]="{'is-invalid': form.submitted && form_observation.invalid}">
          </textarea>
          <label for="observation">{{ 'page.declarations.synthese.modal.saisir-revendication.observation' | translate }}</label>
        </p-floatlabel>
      </div>

    </div>
  </form>
  <!-- Fin formulaire de saisie d'une revendication -->

  <!-- Boutons dans le footer du dialog -->
  <ng-template pTemplate="footer">
    <p-button
      type="button"
      [outlined]="true"
      icon="pi pi-times"
      [label]="'label.annuler' | translate"
      (click)="onClose()"
      (keydown.enter)="onClose()">
    </p-button>
    <p-button
      type="button"
      icon="pi pi-plus"
      [label]="'page.declarations.synthese.modal.synthese-saisies-revendications.ajouterLot' | translate"
      (click)="onAjouterLot()"
      (keydown.enter)="onAjouterLot()">
    </p-button>
    <p-button
      type="button"
      icon="pi pi-arrow-right"
      [label]="'label.suivant' | translate"
      [disabled]="!formGroup.valid"
      (click)="onTerminer()"
      (keydown.enter)="onTerminer()">
    </p-button>
  </ng-template>

</p-dialog>
